import React from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import '../../../../styles/layout.css';
const Layout = ({ children, module }) => {
  const handleSignOut = () => {
    console.log('Signing out...');
  };

  return (
    <div className="buyer-dashboard layout-css">
      <Header onSignOut={handleSignOut} />
      <div className="display-flex">
        <div className="sidebar-css">
          <Sidebar module = {module} />
        </div>
        <div className="content-css">
       {/* <Breadcrumbs/> */}
          {children}
        </div>
      </div>
    </div>
  );
};
export default Layout;